const accessMenu = ({ PERMISSIONS, NOTIFY = [] }) => {
  const demo_version = false
  const permissions = []
  const accounts = [], human_resources = [], masters = [], purchases = [], sales = [], stocks = [], reports = [], notifications = [], overview_dashboards = []
  PERMISSIONS.forEach(item => permissions[item.menu_name_en] = { permission_view: item.permission_view })

  const _target = ''
  // const _target = '_blank'

  if ((permissions['notifications-setting'] && permissions['notifications-setting'].permission_view) || demo_version) {
    notifications.push({
      _tag: "CSidebarNavItem",
      name: "จัดการแจ้งเตือน",
      to: "/notifications-setting",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-bell" />,
      exact: false,
      badge: {
        color: 'danger',
        text: NOTIFY.notify_notification_setting ? NOTIFY.notify_notification_setting > 99 ? "99+" : NOTIFY.notify_notification_setting : '',
      },
    })
  }

  if ((permissions['dashboard-sale'] && permissions['dashboard-sale'].permission_view) || demo_version) {
    overview_dashboards.push({
      _tag: 'CSidebarNavItem',
      name: 'ภาพรวมซื้อ',
      to: '/overview-dashboard/dashboard-sale',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-o" />,
      exact: false,
    })
  }
  if ((permissions['dashboard-purchase'] && permissions['dashboard-purchase'].permission_view) || demo_version) {
    overview_dashboards.push({
      _tag: 'CSidebarNavItem',
      name: 'ภาพรวมขาย',
      to: '/overview-dashboard/dashboard-purchase',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-o" />,
      exact: false,
    })
  }

  if ((permissions['account-stucture'] && permissions['account-stucture'].permission_view) || demo_version) {
    accounts.push({
      _tag: "CSidebarNavItem",
      name: "ผังบัญชี",
      to: "/account-stucture",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-book" />,
      exact: false,
    })
  }


  const schedule_items = []
  if ((permissions['schedule-plan'] && permissions['schedule-plan'].permission_view) || demo_version) {
    schedule_items.push({
      _tag: "CSidebarNavItem",
      name: "ประเภทนัดหมาย",
      to: "/schedule",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-align-left" />,
      exact: false,
    })
  }
  if ((permissions['schedule-plan'] && permissions['schedule-plan'].permission_view) || demo_version) {
    schedule_items.push({
      _tag: "CSidebarNavItem",
      name: "เปิดรับจองนัดหมาย",
      to: "/schedule-plan",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-calendar-plus-o" />,
      exact: false,
    })
  }
  if ((permissions['schedule-plan'] && permissions['schedule-plan'].permission_view) || demo_version) {
    schedule_items.push({
      _tag: "CSidebarNavItem",
      name: "รายการนัดหมาย",
      to: "/schedule-plan-salesman",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-calendar" />,
      exact: false,
      badge: {
        color: 'danger',
        text: NOTIFY.notify_schedule_plans ? NOTIFY.notify_schedule_plans : '',
      },
    })
  }
  schedule_items.length && accounts.push({
    _tag: "CSidebarNavDropdown",
    name: "นัดหมาย",
    route: '/marketing',
    icon: <i className="c-sidebar-nav-icon fa fa-calendar-o" />,
    _children: schedule_items,
  })

  const finance_items = []

  if ((permissions['billing-note-customer'] && permissions['billing-note-customer'].permission_view) || demo_version) {
    finance_items.push({
      _tag: 'CSidebarNavItem',
      name: 'วางบิลลูกค้า',
      to: '/finance/billing-note-customer',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
      exact: false,
      badge: {
        color: 'danger',
        text: NOTIFY.notify_billing_note_customers ? NOTIFY.notify_billing_note_customers : '',
      },
    })
  }
  if ((permissions['billing-note-supplier'] && permissions['billing-note-supplier'].permission_view) || demo_version) {
    finance_items.push({
      _tag: 'CSidebarNavItem',
      name: 'รับวางบิลผู้ขาย',
      to: '/finance/billing-note-supplier',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
      exact: false,
      badge: {
        color: 'danger',
        text: NOTIFY.notify_billing_note_suppliers ? NOTIFY.notify_billing_note_suppliers : '',
      },
    })
  }
  if ((permissions['finance-debit'] && permissions['finance-debit'].permission_view) || demo_version) {
    finance_items.push({
      _tag: 'CSidebarNavItem',
      name: 'รับชำระหนี้',
      to: '/finance/finance-debit',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
      exact: false,
      badge: {
        color: 'danger',
        text: NOTIFY.notify_finance_debits  ? NOTIFY.notify_finance_debits : '',
      },
    })
  }
  if ((permissions['finance-credit'] && permissions['finance-credit'].permission_view) || demo_version) {
    finance_items.push({
      _tag: 'CSidebarNavItem',
      name: 'จ่ายชำระหนี้',
      to: '/finance/finance-credit',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
      exact: false,
      badge: {
        color: 'danger',
        text: NOTIFY.notify_finance_credits ? NOTIFY.notify_finance_credits : '',
      },
    })
  }
  if ((permissions['expenses-note'] && permissions['expenses-note'].permission_view) || demo_version) {
    finance_items.push({
      _tag: 'CSidebarNavItem',
      name: 'ค่าใช้จ่ายอื่นๆ',
      to: '/finance/expenses-note',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
      exact: false,
    })
  }
  if ((permissions['petty-cash-withdrawal'] && permissions['petty-cash-withdrawal'].permission_view) || demo_version) {
    finance_items.push({
      _tag: "CSidebarNavItem",
      name: "ใบเบิกเงินสดย่อย",
      to: "/petty-cash-withdrawal",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
      exact: false,
      badge: {
        color: 'danger',
        text: NOTIFY.notify_petty_cash_withdrawals  ? NOTIFY.notify_petty_cash_withdrawals : '',
      },
    })
  }

  if ((permissions['withdrawal'] && permissions['withdrawal'].permission_view) || demo_version) {
    finance_items.push({
      _tag: "CSidebarNavItem",
      name: "ใบเบิกเงินวันที่ 10 และ 20",
      to: "/finance/withdrawal",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
      exact: false,
    })
  }

  if ((permissions['emergency-withdrawal'] && permissions['emergency-withdrawal'].permission_view) || demo_version) {
    finance_items.push({
      _tag: "CSidebarNavItem",
      name: "ใบเบิกเงินฉุกเฉิน",
      to: "/finance/emergency-withdrawal",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
      exact: false,
    })
  }

  if ((permissions['borrow'] && permissions['borrow'].permission_view) || demo_version) {
    finance_items.push({
      _tag: "CSidebarNavItem",
      name: "ใบเบิกเงินยืม",
      to: "/finance/borrow",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
      exact: false,
    })
  }

  if ((permissions['savings'] && permissions['savings'].permission_view) || demo_version) {
    finance_items.push({
      _tag: "CSidebarNavItem",
      name: "ใบเบิกเงินฝาก",
      to: "/finance/savings",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
      exact: false,
    })
  }

  if ((permissions['asset-type'] && permissions['asset-type'].permission_view) || demo_version) {
    finance_items.push({
      _tag: "CSidebarNavItem",
      name: "หมวดหมู่ทรัพย์สิน",
      to: "/finance/asset-type",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
      exact: false,

    })
  }
  if ((permissions['asset-group'] && permissions['asset-group'].permission_view) || demo_version) {
    finance_items.push({
      _tag: "CSidebarNavItem",
      name: "กลุ่มทรัพย์สิน",
      to: "/finance/asset-group",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
      exact: false,

    })
  }
  if ((permissions['asset'] && permissions['asset'].permission_view) || demo_version) {
    finance_items.push({
      _tag: "CSidebarNavItem",
      name: "รายการทรัพย์สิน",
      to: "/finance/asset",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
      exact: false,

    })
  }


  finance_items.length && accounts.push({
    _tag: "CSidebarNavDropdown",
    name: "การเงิน",
    route: '/finance',
    icon: <i className="c-sidebar-nav-icon fa fa-list" />,
    _children: finance_items,
  })

  const account_revenue_items = []
  if ((permissions['account-revenue'] && permissions['account-revenue'].permission_view) || demo_version) {
    account_revenue_items.push({
      _tag: "CSidebarNavItem",
      name: "ผังบัญชีของสรรพากร",
      to: "/account-revenue-stucture",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-book" />,
      exact: false,
    })
  }
  if ((permissions['account-revenue'] && permissions['account-revenue'].permission_view) || demo_version) {
    account_revenue_items.push({
      _tag: "CSidebarNavItem",
      name: "จัดการรายการซื้อ-ขาย",
      to: "/manage-account/account-revenue-journal",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-book" />,
      exact: false,
    })
  }
  account_revenue_items.length && accounts.push({
    _tag: "CSidebarNavDropdown",
    name: "จัดการบัญชีสรรพากร",
    route: '/account-revenue-manage',
    icon: <i className="c-sidebar-nav-icon fa fa-list" />,
    _children: account_revenue_items,
  })

  const journal_items = []
  if ((permissions['journal-general'] && permissions['journal-general'].permission_view) || demo_version) {
    journal_items.push({
      _tag: 'CSidebarNavItem',
      name: 'สมุดรายวันทั่วไป',
      to: '/journal/journal-general',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-book" />,
      exact: false,
    })
  }
  if ((permissions['journal-cash-purchase'] && permissions['journal-cash-purchase'].permission_view) || demo_version) {
    journal_items.push({
      _tag: 'CSidebarNavItem',
      name: 'สมุดรายวันซื้อสด',
      to: '/journal/journal-cash-purchase',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-book" />,
      exact: false,
    })
  }
  if ((permissions['journal-credit-purchase'] && permissions['journal-credit-purchase'].permission_view) || demo_version) {
    journal_items.push({
      _tag: 'CSidebarNavItem',
      name: 'สมุดรายวันซื้อเชื่อ',
      to: '/journal/journal-credit-purchase',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-book" />,
      exact: false,
    })
  }
  if ((permissions['journal-cash-sale'] && permissions['journal-cash-sale'].permission_view) || demo_version) {
    journal_items.push({
      _tag: 'CSidebarNavItem',
      name: 'สมุดรายวันขายสด',
      to: '/journal/journal-cash-sale',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-book" />,
      exact: false,
    })
  }
  if ((permissions['journal-credit-sale'] && permissions['journal-credit-sale'].permission_view) || demo_version) {
    journal_items.push({
      _tag: 'CSidebarNavItem',
      name: 'สมุดรายวันขายเชื่อ',
      to: '/journal/journal-credit-sale',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-book" />,
      exact: false,
    })
  }
  if ((permissions['journal-purchase-return'] && permissions['journal-purchase-return'].permission_view) || demo_version) {
    journal_items.push({
      _tag: 'CSidebarNavItem',
      name: 'สมุดรายวันส่งคืน',
      to: '/journal/journal-purchase-return',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-book" />,
      exact: false,
    })
  }
  if ((permissions['journal-credit-note-supplier'] && permissions['journal-credit-note-supplier'].permission_view) || demo_version) {
    journal_items.push({
      _tag: 'CSidebarNavItem',
      name: 'สมุดรายวันรับลดหนี้',
      to: '/journal/journal-credit-note-supplier',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-book" />,
      exact: false,
    })
  }
  if ((permissions['journal-debit-note-supplier'] && permissions['journal-debit-note-supplier'].permission_view) || demo_version) {
    journal_items.push({
      _tag: 'CSidebarNavItem',
      name: 'สมุดรายวันรับเพิ่มหนี้',
      to: '/journal/journal-debit-note-supplier',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-book" />,
      exact: false,
    })
  }
  if ((permissions['journal-credit-note-customer'] && permissions['journal-credit-note-customer'].permission_view) || demo_version) {
    journal_items.push({
      _tag: 'CSidebarNavItem',
      name: 'สมุดรายวันลดหนี้/รับคืน ลูกค้า',
      to: '/journal/journal-credit-note-customer',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-book" />,
      exact: false,
    })
  }
  if ((permissions['journal-debit-note-customer'] && permissions['journal-debit-note-customer'].permission_view) || demo_version) {
    journal_items.push({
      _tag: 'CSidebarNavItem',
      name: 'สมุดรายวันเพิ่มหนี้ลูกค้า',
      to: '/journal/journal-debit-note-customer',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-book" />,
      exact: false,
    })
  }
  if ((permissions['journal-cash-receipt'] && permissions['journal-cash-receipt'].permission_view) || demo_version) {
    journal_items.push({
      _tag: 'CSidebarNavItem',
      name: 'สมุดรายวันรับเงิน',
      to: '/journal/journal-cash-receipt',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-book" />,
      exact: false,
    })
  }
  if ((permissions['journal-cash-payment'] && permissions['journal-cash-payment'].permission_view) || demo_version) {
    journal_items.push({
      _tag: 'CSidebarNavItem',
      name: 'สมุดรายวันจ่ายเงิน',
      to: '/journal/journal-cash-payment',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-book" />,
      exact: false,
    })
  }

  if ((permissions['journal-stock-issue'] && permissions['journal-stock-issue'].permission_view) || demo_version) {
    journal_items.push({
      _tag: 'CSidebarNavItem',
      name: 'สมุดรายวันโอนย้ายสินค้า',
      to: '/journal/journal-stock-issue',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-book" />,
      exact: false,
    })
  }

  journal_items.length && accounts.push({
    _tag: "CSidebarNavDropdown",
    name: "สมุดรายวัน (Journal)",
    route: '/journal',
    icon: <i className="c-sidebar-nav-icon fa fa-list" />,
    _children: journal_items,
  })

  const manage_bank_items = []
  if ((permissions['cheque-receive'] && permissions['cheque-receive'].permission_view) || demo_version) {
    manage_bank_items.push({
      _tag: 'CSidebarNavItem',
      name: 'ทะเบียนเช็ครับ',
      to: '/manage-bank/cheque-receive',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
      exact: false,
    })
  }
  if ((permissions['cheque-pay'] && permissions['cheque-pay'].permission_view) || demo_version) {
    manage_bank_items.push({
      _tag: 'CSidebarNavItem',
      name: 'ทะเบียนเช็คจ่าย',
      to: '/manage-bank/cheque-pay',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
      exact: false,
    })
  }
  if ((permissions['book-bank'] && permissions['book-bank'].permission_view) || demo_version) {
    manage_bank_items.push({
      _tag: 'CSidebarNavItem',
      name: 'สมุดบัญชี',
      to: '/manage-bank/book-bank',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-book" />,
      exact: false,
    })
  }
  if ((permissions['bank'] && permissions['bank'].permission_view) || demo_version) {
    manage_bank_items.push({
      _tag: 'CSidebarNavItem',
      name: 'ธนาคาร',
      to: '/manage-bank/bank',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-bank" />,
      exact: false,
    })
  }

  manage_bank_items.length && accounts.push({
    _tag: "CSidebarNavDropdown",
    name: "จัดการธนาคาร",
    route: '/manage-bank',
    icon: <i className="c-sidebar-nav-icon fa fa-list" />,
    _children: manage_bank_items,
  })

  const manage_account_items = []
  if ((permissions['account-setting'] && permissions['account-setting'].permission_view) || demo_version) {
    manage_account_items.push({
      _tag: 'CSidebarNavItem',
      name: 'บัญชีลงรายวัน',
      to: '/manage-account/account-setting',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-cog" />,
      exact: false,
    })
  }

  if ((permissions['debit-receipt'] && permissions['debit-receipt'].permission_view) || demo_version) {
    manage_account_items.push({
      _tag: 'CSidebarNavItem',
      name: 'วิธีการชำระ POS',
      to: '/manage-account/debit-receipt',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-cog" />,
      exact: false,
    })
  }
  if ((permissions['debit-receipt-type'] && permissions['debit-receipt-type'].permission_view) || demo_version) {
    manage_account_items.push({
      _tag: 'CSidebarNavItem',
      name: 'ประเภทการชำระ POS',
      to: '/manage-account/debit-receipt-type',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-cog" />,
      exact: false,
    })
  }

  if ((permissions['debit-account'] && permissions['debit-account'].permission_view) || demo_version) {
    manage_account_items.push({
      _tag: 'CSidebarNavItem',
      name: 'วิธีการรับชำระ',
      to: '/manage-account/debit-account',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-cog" />,
      exact: false,
    })
  }
  if ((permissions['credit-account'] && permissions['credit-account'].permission_view) || demo_version) {
    manage_account_items.push({
      _tag: 'CSidebarNavItem',
      name: 'วิธีการจ่ายชำระ',
      to: '/manage-account/credit-account',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-cog" />,
      exact: false,
    })
  }
  if ((permissions['paper-lock'] && permissions['paper-lock'].permission_view) || demo_version) {
    manage_account_items.push({
      _tag: 'CSidebarNavItem',
      name: 'ล็อกงวดบัญชี',
      to: '/manage-account/paper-lock',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-lock" />,
      exact: false,
    })
  }

  manage_account_items.length && accounts.push({
    _tag: "CSidebarNavDropdown",
    name: "จัดการบัญชี",
    route: '/manage-account',
    icon: <i className="c-sidebar-nav-icon fa fa-list" />,
    _children: manage_account_items,
  })

  // if ((permissions['human-resource-monitor'] && permissions['human-resource-monitor'].permission_view) || demo_version) {
  //   human_resources.push({
  //     _tag: 'CSidebarNavItem',
  //     name: 'หน้าจอทีวีฝ่ายบุคคล',
  //     to: '/human-resource/human-resource-monitor',
  // target: _target,
  //     icon: <i className="c-sidebar-nav-icon fa fa-television" />,
  //     exact: false,
  //   })
  // }

  if ((permissions['human-resource-report'] && permissions['human-resource-report'].permission_view) || demo_version) {
    human_resources.push({
      _tag: 'CSidebarNavItem',
      name: 'นำเข้าข้อมูลการทำงาน',
      to: '/human-resource/human-resource-import',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-download" />,
      exact: false,
    })
  }

  let hr_reports = []

  if ((permissions['human-resource-report'] && permissions['human-resource-report'].permission_view) || demo_version) {
    hr_reports.push({
      _tag: 'CSidebarNavItem',
      name: 'รายงานเวลาการทำงาน',
      to: '/human-resource/human-resource-report',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-o" />,
      exact: false,
    })
  }

  if ((permissions['human-resource-report'] && permissions['human-resource-report'].permission_view) || demo_version) {
    hr_reports.push({
      _tag: 'CSidebarNavItem',
      name: 'รายงานไม่ลาลามาสาย',
      to: '/human-resource/human-resource-report-time',
      icon: <i className="c-sidebar-nav-icon fa fa-file-o" />,
      exact: false,
    })
  }

  if ((permissions['human-resource-report'] && permissions['human-resource-report'].permission_view) || demo_version) {
    hr_reports.push({
      _tag: 'CSidebarNavItem',
      name: 'รายงานรายปี',
      to: '/human-resource/human-resource-report-year',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-o" />,
      exact: false,
    })
  }

  hr_reports.length && human_resources.push({
    _tag: "CSidebarNavDropdown",
    name: "รายงาน",
    route: '/human-resource/human-resource-report',
    icon: <i className="c-sidebar-nav-icon fa fa-list" />,
    _children: hr_reports,
  })

  if ((permissions['human-resource-dashboard'] && permissions['human-resource-dashboard'].permission_view) || demo_version) {
    human_resources.push({
      _tag: 'CSidebarNavItem',
      name: 'แดชบอร์ด',
      to: '/human-resource/human-resource-dashboard',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-bar-chart" />,
      exact: false,
    })
  }
  if ((permissions['employee'] && permissions['employee'].permission_view) || demo_version) {
    human_resources.push({
      _tag: 'CSidebarNavItem',
      name: 'พนักงาน',
      to: '/human-resource/employee',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-id-card" />,
      exact: false,
    })
  }
  if ((permissions['employee-position'] && permissions['employee-position'].permission_view) || demo_version) {
    human_resources.push({
      _tag: 'CSidebarNavItem',
      name: 'ตำแหน่ง',
      to: '/human-resource/employee-position',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-suitcase" />,
      exact: false,
    })
  }
  if ((permissions['department'] && permissions['department'].permission_view) || 1) {
    human_resources.push({
      _tag: 'CSidebarNavItem',
      name: 'แผนก/ฝ่าย',
      to: '/human-resource/department',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-users" />,
      exact: false,
    })
  }
  if ((permissions['postpone-break'] && permissions['postpone-break'].permission_view) || demo_version) {
    human_resources.push({
      _tag: 'CSidebarNavItem',
      name: 'ใบเลื่อนเบรค/ลาครึ่งวัน',
      to: '/human-resource/postpone-break',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-o" />,
      exact: false,
    })
  }
  // if ((permissions['time-work'] && permissions['time-work'].permission_view) || demo_version) {
  //   human_resources.push({
  //     _tag: 'CSidebarNavItem',
  //     name: 'ลงเวลาทำงาน',
  //     to: '/human-resource/time-work',
  // target: _target,
  //     icon: <i className="c-sidebar-nav-icon fa fa-calendar" />,
  //     exact: false,
  //   })
  // }
  if ((permissions['time-work'] && permissions['time-work'].permission_view) || demo_version) {
    human_resources.push({
      _tag: 'CSidebarNavItem',
      name: 'ใบทำงานล่วงเวลา (OT)',
      to: '/human-resource/over-time-work',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-calendar" />,
      exact: false,
    })
  }
  if ((permissions['payroll-default'] && permissions['payroll-default'].permission_view) || demo_version) {
    human_resources.push({
      _tag: 'CSidebarNavItem',
      name: 'ตั้งค่าเงินเดือน',
      to: '/human-resource/payroll-default',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-money" />,
      exact: false,
    })
  }
  if ((permissions['salary-pay-slip'] && permissions['salary-pay-slip'].permission_view) || demo_version) {
    human_resources.push({
      _tag: 'CSidebarNavItem',
      name: 'ใบแจ้งเงินเดือน',
      to: '/human-resource/salary-pay-slip',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-credit-card" />,
      exact: false,
    })
  }
  if ((permissions['salary-payment'] && permissions['salary-payment'].permission_view) || demo_version) {
    human_resources.push({
      _tag: 'CSidebarNavItem',
      name: 'บันทึกการชำระเงินเดือน',
      to: '/human-resource/salary-payment',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-list-alt" />,
      exact: false,
    })
  }
  const policy_items = []
  if ((permissions['policy'] && permissions['policy'].permission_view) || demo_version) {
    policy_items.push({
      _tag: 'CSidebarNavItem',
      name: 'จัดการนโยบายบริษัท',
      to: '/human-resource/policy',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-pencil-square" />,
      exact: false,
    })
  }
  if ((permissions['policy-detail'] && permissions['policy-detail'].permission_view) || demo_version) {
    policy_items.push({
      _tag: 'CSidebarNavItem',
      name: 'รายละเอียดนโยบายบริษัท',
      to: '/human-resource/policy-detail',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-pencil-square" />,
      exact: false,
    })
  }
  policy_items.length && human_resources.push({
    _tag: "CSidebarNavDropdown",
    name: "นโยบายบริษัท",
    route: '/human-resource/policy',
    icon: <i className="c-sidebar-nav-icon fa fa-building-o" />,
    _children: policy_items,
  })

  const news_items = []
  if ((permissions['news'] && permissions['news'].permission_view) || demo_version) {
    news_items.push({
      _tag: 'CSidebarNavItem',
      name: 'จัดการข่าวสาร',
      to: '/human-resource/news',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-newspaper-o" />,
      exact: false,
    })
  }
  if ((permissions['news-detail'] && permissions['news-detail'].permission_view) || demo_version) {
    news_items.push({
      _tag: 'CSidebarNavItem',
      name: 'รายละเอียดข่าวสาร',
      to: '/human-resource/news-detail',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-newspaper-o" />,
      exact: false,
    })
  }
  news_items.length && human_resources.push({
    _tag: "CSidebarNavDropdown",
    name: "ข่าวสาร",
    route: '/human-resource/news',
    icon: <i className="c-sidebar-nav-icon fa fa-calendar" />,
    _children: news_items,
  })

  if ((permissions['recruitment'] && permissions['recruitment'].permission_view) || demo_version) {
    human_resources.push({
      _tag: 'CSidebarNavItem',
      name: 'ประกาศรับสมัครงาน',
      to: '/human-resource/recruitment',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-bullhorn" />,
      exact: false,
    })
  }
  if ((permissions['team'] && permissions['team'].permission_view) || demo_version) {
    human_resources.push({
      _tag: 'CSidebarNavItem',
      name: 'ทีม',
      to: '/human-resource/team',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-users" />,
      exact: false,
    })
  }
  if ((permissions['day-off'] && permissions['day-off'].permission_view) || demo_version) {
    human_resources.push({
      _tag: 'CSidebarNavItem',
      name: 'ปฏิทินวันหยุด',
      to: '/human-resource/day-off',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-calendar-o" />,
      exact: false,
    })
  }
  const leave = []
  if ((permissions['leave'] && permissions['leave'].permission_view) || demo_version) {
    leave.push({
      _tag: 'CSidebarNavItem',
      name: 'ลาหยุด',
      to: '/human-resource/leave',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-pencil-square" />,
      exact: false,
    })
  }
  if ((permissions['leave-type'] && permissions['leave-type'].permission_view) || demo_version) {
    leave.push({
      _tag: 'CSidebarNavItem',
      name: 'จัดการประเภทลาหยุด',
      to: '/human-resource/leave-type',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-pencil-square" />,
      exact: false,
    })
  }
  leave.length && human_resources.push({
    _tag: "CSidebarNavDropdown",
    name: "ลาหยุด",
    route: '/human-resource/leave',
    icon: <i className="c-sidebar-nav-icon fa fa fa-calendar" />,
    _children: leave,
  })
  if ((permissions['change-day-off'] && permissions['change-day-off'].permission_view) || demo_version) {
    human_resources.push({
      _tag: 'CSidebarNavItem',
      name: 'แลกวันหยุด',
      to: '/human-resource/change-day-off',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-retweet" />,
      exact: false,
    })
  }

  const employee_warning = []
  if ((permissions['employee-warning'] && permissions['employee-warning'].permission_view) || demo_version) {
    employee_warning.push({
      _tag: 'CSidebarNavItem',
      name: 'ใบเตือน',
      to: '/human-resource/employee-warning',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-pencil-square" />,
      exact: false,
    })
  }
  if ((permissions['employee-warning-type'] && permissions['employee-warning-type'].permission_view) || demo_version) {
    employee_warning.push({
      _tag: 'CSidebarNavItem',
      name: 'จัดการประเภทใบเตือน',
      to: '/human-resource/employee-warning-type',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-pencil-square" />,
      exact: false,
    })
  }
  employee_warning.length && human_resources.push({
    _tag: "CSidebarNavDropdown",
    name: "ใบเตือน",
    route: '/human-resource/employee-warning',
    icon: <i className="c-sidebar-nav-icon fa fa-exclamation-triangle" />,
    _children: employee_warning,
  })

  if ((permissions['employee-detail'] && permissions['employee-detail'].permission_view) || demo_version) {
    human_resources.push({
      _tag: 'CSidebarNavItem',
      name: 'รายละเอียดการทำงาน',
      to: '/human-resource/employee-detail',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-list" />,
      exact: false,
    })
  }

  if ((permissions['day-off-user'] && permissions['day-off-user'].permission_view) || demo_version) {
    human_resources.push({
      _tag: 'CSidebarNavItem',
      name: 'ตารางวันหยุด',
      to: '/human-resource/day-off-user',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-building-o" />,
      exact: false,
    })
  }

  if ((permissions['minimum-saving'] && permissions['minimum-saving'].permission_view) || demo_version) {
    human_resources.push({
      _tag: 'CSidebarNavItem',
      name: 'เงินออมขั้นต่ำพนักงาน',
      to: '/human-resource/minimum-saving',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-building-o" />,
      exact: false,
    })
  }

  const manage_product_items = []
  if ((permissions['product'] && permissions['product'].permission_view) || demo_version) {
    manage_product_items.push({
      _tag: 'CSidebarNavItem',
      name: 'รายการสินค้า',
      to: '/manage-product/product',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-cube" />,
      exact: false,
    })
  }
  if ((permissions['product-price-history'] && permissions['product-price-history'].permission_view) || demo_version) {
    manage_product_items.push({
      _tag: 'CSidebarNavItem',
      name: 'ประวัติแก้ไขราคาสินค้า',
      to: '/manage-product/product-price-history',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-cube" />,
      exact: false,
    })
  }
  if ((permissions['shortcut-product'] && permissions['shortcut-product'].permission_view) || demo_version) {
    manage_product_items.push({
      _tag: 'CSidebarNavItem',
      name: 'สินค้าขายบ่อย',
      to: '/manage-product/shortcut-product',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-cubes" />,
      exact: false,
    })
  }
  // if ((permissions['product-group'] && permissions['product-group'].permission_view) || demo_version) {
  //   manage_product_items.push({
  //     _tag: 'CSidebarNavItem',
  //     name: 'กลุ่มสินค้า',
  //     to: '/manage-product/product-group',
  // target: _target,
  //     icon: <i className="c-sidebar-nav-icon fa fa-cubes" />,
  //     exact: false,
  //   })
  // }
  if ((permissions['product-group-discound'] && permissions['product-group-discound'].permission_view) || demo_version) {
    manage_product_items.push({
      _tag: 'CSidebarNavItem',
      name: 'กลุ่มลดจำนวน',
      to: '/manage-product/product-group-discound',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-cubes" />,
      exact: false,
    })
  }
  if ((permissions['product-category'] && permissions['product-category'].permission_view) || demo_version) {
    manage_product_items.push({
      _tag: 'CSidebarNavItem',
      name: 'หมวดหมู่สินค้า',
      to: '/manage-product/product-category',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-cubes" />,
      exact: false,
    })
  }

  if ((permissions['product-type'] && permissions['product-type'].permission_view) || demo_version) {
    manage_product_items.push({
      _tag: 'CSidebarNavItem',
      name: 'ประเภทสินค้า',
      to: '/manage-product/product-type',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-cubes" />,
      exact: false,
    })
  }
  if ((permissions['product-unit'] && permissions['product-unit'].permission_view) || demo_version) {
    manage_product_items.push({
      _tag: 'CSidebarNavItem',
      name: 'หน่วยสินค้า',
      to: '/manage-product/product-unit',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-cubes" />,
      exact: false,
    })
  }
  if ((permissions['product-brand'] && permissions['product-brand'].permission_view) || demo_version) {
    manage_product_items.push({
      _tag: 'CSidebarNavItem',
      name: 'ยี่ห้อสินค้า',
      to: '/manage-product/product-brand',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-cubes" />,
      exact: false,
    })
  }

  manage_product_items.length && masters.push({
    _tag: "CSidebarNavDropdown",
    name: "จัดการสินค้า",
    route: '/manage-product',
    icon: <i className="c-sidebar-nav-icon fa fa-list" />,
    _children: manage_product_items,
  })

  const manage_customer_items = []
  if ((permissions['customer'] && permissions['customer'].permission_view) || demo_version) {
    manage_customer_items.push({
      _tag: 'CSidebarNavItem',
      name: 'ลูกค้า',
      to: '/manage-customer/customer',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-address-card-o" />,
      exact: false,
    })
  }
  if ((permissions['customer-type'] && permissions['customer-type'].permission_view) || demo_version) {
    manage_customer_items.push({
      _tag: 'CSidebarNavItem',
      name: 'ประเภทลูกค้า',
      to: '/manage-customer/customer-type',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-users" />,
      exact: false,
    })
  }

  manage_customer_items.length && masters.push({
    _tag: "CSidebarNavDropdown",
    name: "จัดการลูกค้า",
    route: '/manage-customer',
    icon: <i className="c-sidebar-nav-icon fa fa-list" />,
    _children: manage_customer_items,
  })

  const manage_supplier_items = []
  if ((permissions['supplier'] && permissions['supplier'].permission_view) || demo_version) {
    manage_supplier_items.push({
      _tag: "CSidebarNavItem",
      name: "ผู้ขาย",
      to: "/manage-supplier/supplier",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-building-o" />,
      exact: false,
    })
  }
  if ((permissions['salesman'] && permissions['salesman'].permission_view) || demo_version) {
    manage_supplier_items.push({
      _tag: "CSidebarNavItem",
      name: "พนักงานขาย",
      to: "/manage-salesman/salesman",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-building-o" />,
      exact: false,
    })
  }


  manage_supplier_items.length && masters.push({
    _tag: "CSidebarNavDropdown",
    name: "จัดการผู้ขาย",
    route: '/manage-supplier',
    icon: <i className="c-sidebar-nav-icon fa fa-list" />,
    _children: manage_supplier_items,
  })

  const manage_user_items = []
  if ((permissions['user'] && permissions['user'].permission_view) || demo_version) {
    manage_user_items.push({
      _tag: 'CSidebarNavItem',
      name: 'ผู้ใช้งานระบบ',
      to: '/manage-user/user',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-user" />,
      exact: false,
    })
  }
  if ((permissions['license'] && permissions['license'].permission_view) || demo_version) {
    manage_user_items.push({
      _tag: 'CSidebarNavItem',
      name: 'สิทธิ์การใช้งาน',
      to: '/manage-user/license',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-desktop" />,
      exact: false,
    })
  }
  if ((permissions['user-position'] && permissions['user-position'].permission_view) || demo_version) {
    manage_user_items.push({
      _tag: 'CSidebarNavItem',
      name: 'ตำแหน่ง',
      to: '/manage-user/user-position',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-cogs" />,
      exact: false,
    })
  }

  manage_user_items.length && masters.push({
    _tag: "CSidebarNavDropdown",
    name: "จัดการผู้ใช้",
    route: '/manage-user',
    icon: <i className="c-sidebar-nav-icon fa fa-list" />,
    _children: manage_user_items,
  })

  const manage_company_items = []
  if ((permissions['company-info'] && permissions['company-info'].permission_view) || demo_version) {
    manage_company_items.push({
      _tag: 'CSidebarNavItem',
      name: 'ข้อมูลบริษัท',
      to: '/manage-company/company-info',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-building-o" />,
      exact: false,
    })
  }

  if ((permissions['company-branch'] && permissions['company-branch'].permission_view) || demo_version) {
    manage_company_items.push({
      _tag: 'CSidebarNavItem',
      name: 'สาขาบริษัท',
      to: '/manage-company/company-branch',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-map-marker" />,
      exact: false,
    })
  }
  if ((permissions['company-employee-info'] && permissions['company-employee-info'].permission_view) || demo_version) {
    manage_company_items.push({
      _tag: 'CSidebarNavItem',
      name: 'พนักงานซื้อ',
      to: '/manage-company/company-employee-info',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-user" />,
      exact: false,
    })
  }

  manage_company_items.length && masters.push({
    _tag: "CSidebarNavDropdown",
    name: "จัดการข้อมูลบริษัท",
    route: '/manage-company',
    icon: <i className="c-sidebar-nav-icon fa fa-list" />,
    _children: manage_company_items,
  })

  const carry_items = []
  if ((permissions['product-init'] && permissions['product-init'].permission_view) || demo_version) {
    carry_items.push({
      _tag: 'CSidebarNavItem',
      name: 'สินค้า',
      to: '/carrys/product-init',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
      exact: false,
    })
  }
  if ((permissions['invoice-customer-carry'] && permissions['invoice-customer-carry'].permission_view) || demo_version) {
    carry_items.push({
      _tag: 'CSidebarNavItem',
      name: 'ลูกหนี้คงค้าง',
      to: '/carrys/invoice-customer',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
      exact: false,
    })
  }
  if ((permissions['invoice-supplier-carry'] && permissions['invoice-supplier-carry'].permission_view) || demo_version) {
    carry_items.push({
      _tag: 'CSidebarNavItem',
      name: 'เจ้าหนี้คงค้าง',
      to: '/carrys/invoice-supplier',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
      exact: false,
    })
  }
  if ((permissions['account-carry'] && permissions['account-carry'].permission_view) || demo_version) {
    carry_items.push({
      _tag: 'CSidebarNavItem',
      name: 'บัญชี',
      to: '/carrys/account',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
      exact: false,
    })
  }

  carry_items.length && masters.push({
    _tag: "CSidebarNavDropdown",
    name: "จัดการยกยอดมา",
    route: '/carrys',
    icon: <i className="c-sidebar-nav-icon fa fa-list" />,
    _children: carry_items,
  })
  // ซ่อน PR status
  // if ((permissions['purchase-request-status'] && permissions['purchase-request-status'].permission_view) || demo_version) {
  //   purchases.push({
  //     _tag: "CSidebarNavItem",
  //     name: "สถานะใบขอซื้อ",
  //     to: "/purchase-request-status",
  //     target: _target,
  //     icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
  //     exact: false,
  //   })
  // }
  if ((permissions['purchase-request'] && permissions['purchase-request'].permission_view) || demo_version) {
    purchases.push({
      _tag: "CSidebarNavItem",
      name: "ขอซื้อสินค้า (PR)",
      to: "/purchase-request",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
      exact: false,
      badge: {
        color: 'danger',
        text: NOTIFY.notify_purchase_requests ? NOTIFY.notify_purchase_requests : '',
      },
    })
  }
  if ((permissions['purchase-order'] && permissions['purchase-order'].permission_view) || demo_version) {
    purchases.push({
      _tag: "CSidebarNavItem",
      name: "สั่งซื้อ (PO)",
      to: "/purchase-order",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
      exact: false,
      badge: {
        color: 'danger',
        text: NOTIFY.notify_purchase_orders ? NOTIFY.notify_purchase_orders : '',
      },
    })
  }
  if ((permissions['purchase-deposit'] && permissions['purchase-deposit'].permission_view) || demo_version) {
    purchases.push({
      _tag: "CSidebarNavItem",
      name: "จ่ายเงินมัดจำ",
      to: "/purchase-deposit",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
      exact: false,
    })
  }
  if ((permissions['invoice-supplier'] && permissions['invoice-supplier'].permission_view) || demo_version) {
    purchases.push({
      _tag: "CSidebarNavItem",
      name: "ใบรับสินค้า (RR)",
      to: "/invoice-supplier",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
      exact: false,
      badge: {
        color: 'danger',
        text: NOTIFY.notify_invoice_suppliers ? NOTIFY.notify_invoice_suppliers : '',
      },
    })
  }
  if ((permissions['invoice-supplier-material'] && permissions['invoice-supplier-material'].permission_view) || demo_version) {
    purchases.push({
      _tag: "CSidebarNavItem",
      name: "ใบรับสินค้า (วัสดุใช้ในร้าน)",
      to: "/invoice-supplier-material",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
      exact: false,
      badge: {
        color: 'danger',
        text: NOTIFY.notify_invoice_suppliers ? NOTIFY.notify_invoice_suppliers : '',
      },
    })
  }
  if ((permissions['purchase-return'] && permissions['purchase-return'].permission_view) || demo_version) {
    purchases.push({
      _tag: "CSidebarNavItem",
      name: "ใบส่งคืนสินค้า",
      to: "/purchase-return",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
      exact: false,
      badge: {
        color: 'danger',
        text: NOTIFY.notify_purchase_returns ? NOTIFY.notify_purchase_returns : '',
      },
    })
  }
  if ((permissions['credit-note-supplier'] && permissions['credit-note-supplier'].permission_view) || demo_version) {
    purchases.push({
      _tag: "CSidebarNavItem",
      name: "ใบรับลดหนี้",
      to: "/credit-note-supplier",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
      exact: false,
      badge: {
        color: 'danger',
        text: NOTIFY.notify_credit_note_suppliers ? NOTIFY.notify_credit_note_suppliers : '',
      },
    })
  }
  if ((permissions['debit-note-supplier'] && permissions['debit-note-supplier'].permission_view) || demo_version) {
    purchases.push({
      _tag: "CSidebarNavItem",
      name: "ใบรับเพิ่มหนี้",
      to: "/debit-note-supplier",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
      exact: false,
    })
  }
  const e_commerces = []
  if ((permissions['order'] && permissions['order'].permission_view) || demo_version) {
    e_commerces.push({
      _tag: "CSidebarNavItem",
      name: "ออเดอร์ออนไลน์",
      to: "/e_commerce/order",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-list" />,
      exact: false,
      badge: {
        color: 'danger',
        text: NOTIFY.notify_orders ? NOTIFY.notify_orders > 99 ? "99+" : NOTIFY.notify_orders : '',
      },
    })
  }
  if ((permissions['about-us'] && permissions['about-us'].permission_view) || demo_version) {
    e_commerces.push({
      _tag: "CSidebarNavItem",
      name: "เกี่ยวกับเรา",
      to: "/e_commerce/about-us",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-list" />,
      exact: false,
    })
  }
  if ((permissions['how-to-order'] && permissions['how-to-order'].permission_view) || demo_version) {
    e_commerces.push({
      _tag: "CSidebarNavItem",
      name: "วิธีการสั่งซื้อ",
      to: "/e_commerce/how-to-order",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-list" />,
      exact: false,
    })
  }
  if ((permissions['contact'] && permissions['contact'].permission_view) || demo_version) {
    e_commerces.push({
      _tag: 'CSidebarNavItem',
      name: 'ติดต่อเรา',
      to: '/e_commerce/contact',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-list" />,
      exact: false,
    })
  }
  if ((permissions['gallery'] && permissions['gallery'].permission_view) || demo_version) {
    e_commerces.push({
      _tag: 'CSidebarNavItem',
      name: 'จัดการรูปภาพ',
      to: '/e_commerce/gallery',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-list" />,
      exact: false,
    })
  }
  if ((permissions['payment-method'] && permissions['payment-method'].permission_view) || demo_version) {
    e_commerces.push({
      _tag: "CSidebarNavItem",
      name: "วิธีการชำระเงิน",
      to: "/e_commerce/payment-method",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-list" />,
      exact: false,
    })
  }

  e_commerces.length && sales.push({
    _tag: "CSidebarNavDropdown",
    name: NOTIFY.notify_orders && NOTIFY.notify_orders > 0 ?

      <font style={{ width: '100%' }}>อีคอมเมิร์ซ
        <font className="mr-3 text-center bg-danger" style={{ borderRadius: '5px', width: '23px', float: 'right', color: 'white' }} >
          {NOTIFY.notify_orders}</font></font> :
      <font>อีคอมเมิร์ซ </font>,
    route: '/e_commerce',
    icon: <i className="c-sidebar-nav-icon fa fa-shopping-cart" />,
    _children: e_commerces,
  })

  const marketing_items = []
  if ((permissions['promotion'] && permissions['promotion'].permission_view) || demo_version) {
    marketing_items.push({
      _tag: "CSidebarNavItem",
      name: "โปรโมชั่น",
      to: "/marketing/promotion",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-tag" />,
      exact: false,
    })
  }
  if ((permissions['points'] && permissions['points'].permission_view) || demo_version) {
    marketing_items.push({
      _tag: "CSidebarNavItem",
      name: "ระบบสะสมแต้ม",
      to: "/marketing/points",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-product-hunt" />,
      exact: false,
    })
  }
  if ((permissions['points-transection'] && permissions['points-transection'].permission_view) || demo_version) {
    marketing_items.push({
      _tag: "CSidebarNavItem",
      name: "แต้มเคลื่อนไหว",
      to: "/marketing/points-transection",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-list" />,
      exact: false,
    })
  }
  if ((permissions['redeem-gift'] && permissions['redeem-gift'].permission_view) || demo_version) {
    marketing_items.push({
      _tag: "CSidebarNavItem",
      name: "แลกของแถม",
      to: "/marketing/redeem-gift",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-exchange" />,
      exact: false,
    })
  }

  marketing_items.length && sales.push({
    _tag: "CSidebarNavDropdown",
    name: <font>ส่งเสริมการขาย </font>,
    route: '/marketing',
    icon: <i className="c-sidebar-nav-icon fa fa-tags" />,
    _children: marketing_items,
  })

  if ((permissions['quotation'] && permissions['quotation'].permission_view) || demo_version) {
    sales.push({
      _tag: "CSidebarNavItem",
      name: "ใบเสนอราคา",
      to: "/quotation",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
      exact: false,
    })
  }
  if ((permissions['sale-order'] && permissions['sale-order'].permission_view) || demo_version) {
    sales.push({
      _tag: "CSidebarNavItem",
      name: "ใบสั่งขาย",
      to: "/sale-order",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
      exact: false,
    })
  }
  if ((permissions['sale-deposit'] && permissions['sale-deposit'].permission_view) || demo_version) {
    sales.push({
      _tag: "CSidebarNavItem",
      name: "รับเงินมัดจำ",
      to: "/sale-deposit",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
      exact: false,
    })
  }
  if ((permissions['receipt'] && permissions['receipt'].permission_view) || demo_version) {
    sales.push({
      _tag: "CSidebarNavItem",
      name: "ใบเสร็จรับเงิน",
      to: "/receipt",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
      exact: false,
    })
  }
  if ((permissions['receipt-payment'] && permissions['receipt-payment'].permission_view) || demo_version) {
    sales.push({
      _tag: "CSidebarNavItem",
      name: "อนุมัติการโอน",
      to: "/receipt-payment",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
      exact: false,
      badge: {
        color: 'danger',
        text: NOTIFY.notify_receipt_payments && NOTIFY.notify_receipt_payments.length ? NOTIFY.notify_receipt_payments.length : '',
      },
    })
  }

  if ((permissions['receipt-return'] && permissions['receipt-return'].permission_view) || demo_version) {
    sales.push({
      _tag: "CSidebarNavItem",
      name: "อนุมัติการคืนสินค้า",
      to: "/receipt-return",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
      exact: false,
      badge: {
        color: 'danger',
        text: NOTIFY.notify_receipt_returns && NOTIFY.notify_receipt_returns.length ? NOTIFY.notify_receipt_returns.length : '',
      },
    })
  }

  if ((permissions['sale-return'] && permissions['sale-return'].permission_view) || demo_version) {
    sales.push({
      _tag: "CSidebarNavItem",
      name: "ใบลดหนี้/คืนสินค้า",
      to: "/sale-return",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-download" />,
      exact: false,
    })
  }

  if ((permissions['debit-note-receipt'] && permissions['debit-note-receipt'].permission_view) || demo_version) {
    sales.push({
      _tag: "CSidebarNavItem",
      name: "ใบเพิ่มหนี้",
      to: "/debit-note-receipt",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-download" />,
      exact: false,
    })
  }



  if ((permissions['sale-cut-off'] && permissions['sale-cut-off'].permission_view) || demo_version) {
    sales.push({
      _tag: "CSidebarNavItem",
      name: "รายการส่งยอด",
      to: "/sale-cut-off",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
      exact: false,
      badge: {
        color: 'danger',
        text: NOTIFY.notify_sale_cut_offs ? NOTIFY.notify_sale_cut_offs : '',
      },
    })
  }
  if ((permissions['sale-close-shift'] && permissions['sale-close-shift'].permission_view) || demo_version) {
    sales.push({
      _tag: "CSidebarNavItem",
      name: "รายการปิดกะ",
      to: "/sale-close-shift",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
      exact: false,
    })
  }
  if ((permissions['delivery-note'] && permissions['delivery-note'].permission_view) || demo_version) {
    sales.push({
      _tag: "CSidebarNavItem",
      name: "ใบส่งสินค้า",
      to: "/delivery-note",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
      exact: false,
    })
  }
  if ((permissions['invoice-customer'] && permissions['invoice-customer'].permission_view) || demo_version) {
    sales.push({
      _tag: "CSidebarNavItem",
      name: "ใบกำกับภาษี (IV)",
      to: "/invoice-customer",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
      exact: false,
      badge: {
        color: 'danger',
        text: NOTIFY.notify_invoice_customers ? NOTIFY.notify_invoice_customers : '',
      },
    })
  }

  /// หมายเหตุ ลูกค้าใช้จาก การลดหนี้ จากใบเสร็จแทน /////
  // if ((permissions['credit-note-customer'] && permissions['credit-note-customer'].permission_view) || demo_version) {
  //   sales.push({
  //     _tag: "CSidebarNavItem",
  //     name: "ใบลดหนี้/รับคืนสินค้า",
  //     to: "/credit-note-customer",
  //     target: _target,
  //     icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
  //     exact: false,
  //   })
  // }
  // if ((permissions['debit-note-customer'] && permissions['debit-note-customer'].permission_view) || demo_version) {
  //   sales.push({
  //     _tag: "CSidebarNavItem",
  //     name: "ใบเพิ่มหนี้",
  //     to: "/debit-note-customer",
  //     target: _target,
  //     icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
  //     exact: false,
  //   })
  // }
  if ((permissions['reimbursement'] && permissions['reimbursement'].permission_view) || demo_version) {
    sales.push({
      _tag: "CSidebarNavItem",
      name: "รายการเบิกค่าใช้จ่าย",
      to: "/reimbursement",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
      exact: false,
    })
  }
  if ((permissions['sale-change'] && permissions['sale-change'].permission_view) || demo_version) {
    sales.push({
      _tag: "CSidebarNavItem",
      name: "ใบเปลี่ยนสินค้า",
      to: "/sale-change",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-exchange" />,
      exact: false,
    })
  }

  if ((permissions['stock-search'] && permissions['stock-search'].permission_view) || demo_version) {
    stocks.push({
      _tag: "CSidebarNavItem",
      name: "ค้นหาสินค้า",
      to: "/stock-search",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-search" />,
      exact: false,
    })
  }
  if ((permissions['stock-verify-count'] && permissions['stock-verify-count'].permission_view) || demo_version) {
    stocks.push({
      _tag: "CSidebarNavItem",
      name: "ตรวจนับสินค้า",
      to: "/stock-verify-count",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-edit" />,
      exact: false,
      badge: {
        color: 'danger',
        text: NOTIFY.notify_stock_verify_counts ? NOTIFY.notify_stock_verify_counts : '',
      },
    })
  }
  if ((permissions['stock-verify-count-audit'] && permissions['stock-verify-count-audit'].permission_view) || demo_version) {
    stocks.push({
      _tag: "CSidebarNavItem",
      name: "ตรวจนับสินค้า (Audit)",
      to: "/stock-verify-count-audit",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-edit" />,
      exact: false,
    })
  }
  if ((permissions['stock-poor'] && permissions['stock-poor'].permission_view) || demo_version) {
    stocks.push({
      _tag: "CSidebarNavItem",
      name: "สินค้าเสียหาย",
      to: "/stock-poor",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
      exact: false,
      badge: {
        color: 'danger',
        text: NOTIFY.notify_stock_poors ? NOTIFY.notify_stock_poors : '',
      },
    })
  }
  if ((permissions['stock-issue'] && permissions['stock-issue'].permission_view) || demo_version) {
    stocks.push({
      _tag: "CSidebarNavItem",
      name: "จัดการประเภทเบิกอื่นๆ ",
      to: "/stock-issue-type",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
      exact: false,
    })
  }
  if ((permissions['stock-issue'] && permissions['stock-issue'].permission_view) || demo_version) {
    stocks.push({
      _tag: "CSidebarNavItem",
      name: "เบิกอื่นๆ ",
      to: "/stock-issue",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
      exact: false,
      badge: {
        color: 'danger',
        text: NOTIFY.notify_stock_issues ? NOTIFY.notify_stock_issues : '',
      },
    })
  }
  if ((permissions['stock-return'] && permissions['stock-return'].permission_view) || demo_version) {
    stocks.push({
      _tag: "CSidebarNavItem",
      name: "คืนสินค้า",
      to: "/stock-return",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
      exact: false,
      badge: {
        color: 'danger',
        text: NOTIFY.notify_stock_returns ? NOTIFY.notify_stock_returns : '',
      },
    })
  }
  if ((permissions['stock-request'] && permissions['stock-request'].permission_view) || demo_version) {
    stocks.push({
      _tag: "CSidebarNavItem",
      name: "ขอเบิกระหว่างคลัง",
      to: "/stock-request",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
      exact: false,
    })
  }
  if ((permissions['stock-move'] && permissions['stock-move'].permission_view) || demo_version) {
    stocks.push({
      _tag: "CSidebarNavItem",
      name: "โอนสินค้าภายในสาขา",
      to: "/stock-move",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
      exact: false,
      badge: {
        color: 'danger',
        text: NOTIFY.notify_stock_moves ? NOTIFY.notify_stock_moves : '',
      },
    })
  }
  if ((permissions['stock-receive-move'] && permissions['stock-receive-move'].permission_view) || demo_version) {
    stocks.push({
      _tag: "CSidebarNavItem",
      name: "รับโอนสินค้าภายในสาขา",
      to: "/stock-receive-move",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
      exact: false,
    })
  }
  if ((permissions['stock-request-move-main'] && permissions['stock-request-move-main'].permission_view) || demo_version) {
    stocks.push({
      _tag: "CSidebarNavItem",
      name: "ขอเบิกระหว่างสาขา",
      to: "/stock-request-move-main",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
      exact: false,
    })
  }
  if ((permissions['stock-move-main'] && permissions['stock-move-main'].permission_view) || demo_version) {
    stocks.push({
      _tag: "CSidebarNavItem",
      name: "โอนสินค้าระหว่างสาขา",
      to: "/stock-move-main",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
      exact: false,
      badge: {
        color: 'danger',
        text: NOTIFY.notify_stock_move_mains ? NOTIFY.notify_stock_move_mains : '',
      },
    })
  }
  if ((permissions['stock-receive-move-main'] && permissions['stock-receive-move-main'].permission_view) || demo_version) {
    stocks.push({
      _tag: "CSidebarNavItem",
      name: "รับโอนสินค้าระหว่างสาขา",
      to: "/stock-receive-move-main",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-file-text-o" />,
      exact: false,
    })
  }
  if ((permissions['stock-pack'] && permissions['stock-pack'].permission_view) || demo_version) {
    stocks.push({
      _tag: "CSidebarNavItem",
      name: "รวมสินค้า",
      to: "/stock-pack",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-archive" />,
      exact: false,
      badge: {
        color: 'danger',
        text: NOTIFY.notify_stock_packs ? NOTIFY.notify_stock_packs : '',
      },
    })
  }
  if ((permissions['stock-unpack'] && permissions['stock-unpack'].permission_view) || demo_version) {
    stocks.push({
      _tag: "CSidebarNavItem",
      name: "แยกสินค้า",
      to: "/stock-unpack",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-arrows" />,
      exact: false,
      badge: {
        color: 'danger',
        text: NOTIFY.notify_stock_unpacks ? NOTIFY.notify_stock_unpacks : '',
      },
    })
  }
  // if ((permissions['stock-change'] && permissions['stock-change'].permission_view) || demo_version) {
  //   stocks.push({
  //     _tag: "CSidebarNavItem",
  //     name: "เปลี่ยนสินค้า",
  //     to: "/stock-change",
  //     icon: <i className="c-sidebar-nav-icon fa fa-exchange" />,
  //     exact: false,
  //   })
  // }
  if ((permissions['stock-group'] && permissions['stock-group'].permission_view) || demo_version) {
    stocks.push({
      _tag: "CSidebarNavItem",
      name: "คลังสินค้า",
      to: "/stock-group",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-cubes" />,
      exact: false,
    })
  }
  if ((permissions['stock-setting'] && permissions['stock-setting'].permission_view) || demo_version) {
    stocks.push({
      _tag: "CSidebarNavItem",
      name: "ตั้งค่าคลังสินค้า",
      to: "/stock-setting",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa-gears" />,
      exact: false,
    })
  }

  const sales_items = []
  if ((permissions['report-sale-01'] && permissions['report-sale-01'].permission_view) || demo_version) {
    sales_items.push({
      _tag: 'CSidebarNavItem',
      name: 'รายงานยอดขาย',
      to: '/report/report-sale/report-sale-01',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa fa-file-o" />,
      exact: false,
    })
  }
  if ((permissions['report-sale-02'] && permissions['report-sale-02'].permission_view) || demo_version) {
    sales_items.push({
      _tag: 'CSidebarNavItem',
      name: 'ยอดขายตามเขต',
      to: '/report/report-sale/report-sale-02',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa fa-file-o" />,
      exact: false,
    })
  }
  if ((permissions['report-sale-03'] && permissions['report-sale-03'].permission_view) || demo_version) {
    sales_items.push({
      _tag: 'CSidebarNavItem',
      name: 'ยอดขายรายเดือน',
      to: '/report/report-sale/report-sale-03',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa fa-file-o" />,
      exact: false,
    })
  }

  // sales_items.length && reports.push({
  //   _tag: "CSidebarNavDropdown",
  //   name: "รายงานยอดขาย",
  //   route: '/report/report-sale',
  //   icon: <i className="c-sidebar-nav-icon fa fa-list" />,
  //   _children: sales_items,
  // })

  const report_account_items = []
  if ((permissions['account-stucture'] && permissions['account-stucture'].permission_view) || demo_version) {
    report_account_items.push({
      _tag: 'CSidebarNavItem',
      name: 'ผังบัญชี',
      to: '/report/report-account/account-stucture',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa fa-file-o" />,
      exact: false,
    })
  }
  if ((permissions['journal-move'] && permissions['journal-move'].permission_view) || demo_version) {
    report_account_items.push({
      _tag: 'CSidebarNavItem',
      name: 'ยอดเคลื่อนไหว',
      to: '/report/report-account/journal-move',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa fa-file-o" />,
      exact: false,
    })
  }
  if ((permissions['journal'] && permissions['journal'].permission_view) || demo_version) {
    report_account_items.push({
      _tag: 'CSidebarNavItem',
      name: 'ใบสำคัญ',
      to: '/report/report-account/journal',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa fa-file-o" />,
      exact: false,
    })
  }
  // if ((permissions['budget-test'] && permissions['budget-test'].permission_view) || demo_version) {
  //   report_account_items.push({
  //     _tag: 'CSidebarNavItem',
  //     name: 'งบทดลอง',
  //     to: '/report/report-account/budget-test',
  //     icon: <i className="c-sidebar-nav-icon fa fa fa-file-o" />,
  //     exact: false,
  //   })
  // }
  // if ((permissions['budget-test-year'] && permissions['budget-test-year'].permission_view) || demo_version) {
  //   report_account_items.push({
  //     _tag: 'CSidebarNavItem',
  //     name: 'สรุปงบทดลองประจำปี',
  //     to: '/report/report-account/budget-test-year',
  //     icon: <i className="c-sidebar-nav-icon fa fa fa-file-o" />,
  //     exact: false,
  //   })
  // }
  if ((permissions['account-journal-type'] && permissions['account-journal-type'].permission_view) || demo_version) {
    report_account_items.push({
      _tag: 'CSidebarNavItem',
      name: 'รายงานบัญชีแยกประเภท',
      to: '/report/report-account/account-journal-type',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa fa-file-o" />,
      exact: false,
    })
  }
  if ((permissions['cheque-pay'] && permissions['cheque-pay'].permission_view) || demo_version) {
    report_account_items.push({
      _tag: 'CSidebarNavItem',
      name: 'รายงานเช็คจ่าย',
      to: '/report/report-account/cheque-pay',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa fa-file-o" />,
      exact: false,
    })
  }
  if ((permissions['cheque-receive'] && permissions['cheque-receive'].permission_view) || demo_version) {
    report_account_items.push({
      _tag: 'CSidebarNavItem',
      name: 'รายงานเช็ครับ',
      to: '/report/report-account/cheque-receive',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa fa-file-o" />,
      exact: false,
    })
  }
  if ((permissions['report-payment'] && permissions['report-payment'].permission_view) || demo_version) {
    report_account_items.push({
      _tag: 'CSidebarNavItem',
      name: 'รายงานการจ่ายเงิน',
      to: '/report/report-account/report-payment',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa fa-file-o" />,
      exact: false,
    })
  }
  // if ((permissions['income-statement'] && permissions['income-statement'].permission_view) || demo_version) {
  //   report_account_items.push({
  //     _tag: 'CSidebarNavItem',
  //     name: 'งบกำไรขาดทุน',
  //     to: '/report/report-account/income-statement',
  //     icon: <i className="c-sidebar-nav-icon fa fa fa-file-o" />,
  //     exact: false,
  //   })
  // }
  // if ((permissions['asset'] && permissions['asset'].permission_view) || demo_version) {
  //   report_account_items.push({
  //     _tag: 'CSidebarNavItem',
  //     name: 'รายงานบัญชีทรัพย์สิน',
  //     to: '/report/report-account/asset',
  //     icon: <i className="c-sidebar-nav-icon fa fa fa-file-o" />,
  //     exact: false,
  //   })
  // }
  // if ((permissions['asset-year'] && permissions['asset-year'].permission_view) || demo_version) {
  //   report_account_items.push({
  //     _tag: 'CSidebarNavItem',
  //     name: 'บัญชีทรัพย์สินรายเดือน',
  //     to: '/report/report-account/asset-year',
  //     icon: <i className="c-sidebar-nav-icon fa fa fa-file-o" />,
  //     exact: false,
  //   })
  // }

  report_account_items.length && reports.push({
    _tag: "CSidebarNavDropdown",
    name: "รายงานบัญชี",
    route: '/report/report-account',
    icon: <i className="c-sidebar-nav-icon fa fa-list" />,
    _children: report_account_items,
  })


  const report_account_revenue_items = []
  if ((permissions['account-stucture'] && permissions['account-stucture'].permission_view) || demo_version) {
    report_account_revenue_items.push({
      _tag: 'CSidebarNavItem',
      name: 'ผังบัญชี',
      to: '/report/report-account-revenue/account-stucture-revenue',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa fa-file-o" />,
      exact: false,
    })
  }
  if ((permissions['journal-move'] && permissions['journal-move'].permission_view) || demo_version) {
    report_account_revenue_items.push({
      _tag: 'CSidebarNavItem',
      name: 'ยอดเคลื่อนไหว',
      to: '/report/report-account-revenue/journal-move-revenue',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa fa-file-o" />,
      exact: false,
    })
  }
  if ((permissions['journal'] && permissions['journal'].permission_view) || demo_version) {
    report_account_revenue_items.push({
      _tag: 'CSidebarNavItem',
      name: 'ใบสำคัญ',
      to: '/report/report-account-revenue/journal-revenue',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa fa-file-o" />,
      exact: false,
    })
  }

  report_account_revenue_items.length && reports.push({
    _tag: "CSidebarNavDropdown",
    name: "รายงานบัญชีสรรพากร",
    route: '/report/report-account-revenue',
    icon: <i className="c-sidebar-nav-icon fa fa-list" />,
    _children: report_account_revenue_items,
  })

  const debtor_items = []
  if ((permissions['invoice'] && permissions['invoice'].permission_view) || demo_version) {
    debtor_items.push({
      _tag: 'CSidebarNavItem',
      name: 'ใบกำกับภาษี',
      to: '/report/report-debtor/invoice',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa fa-file-o" />,
      exact: false,
    })
  }
  if ((permissions['billing-note'] && permissions['billing-note'].permission_view) || demo_version) {
    debtor_items.push({
      _tag: 'CSidebarNavItem',
      name: 'ใบวางบิล',
      to: '/report/report-debtor/billing-note',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa fa-file-o" />,
      exact: false,
    })
  }
  if ((permissions['credit-note'] && permissions['credit-note'].permission_view) || demo_version) {
    debtor_items.push({
      _tag: 'CSidebarNavItem',
      name: 'ใบลดหนี้',
      to: '/report/report-debtor/credit-note',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa fa-file-o" />,
      exact: false,
    })
  }
  if ((permissions['debit-note'] && permissions['debit-note'].permission_view) || demo_version) {
    debtor_items.push({
      _tag: 'CSidebarNavItem',
      name: 'ใบเพิ่มหนี้',
      to: '/report/report-debtor/debit-note',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa fa-file-o" />,
      exact: false,
    })
  }
  if ((permissions['finance-debit'] && permissions['finance-debit'].permission_view) || demo_version) {
    debtor_items.push({
      _tag: 'CSidebarNavItem',
      name: 'รับชำระหนี้',
      to: '/report/report-debtor/finance-debit',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa fa-file-o" />,
      exact: false,
    })
  }
  let pos_items = []
  if ((permissions['income-customer'] && permissions['income-customer'].permission_view) || demo_version) {
    pos_items.push({
      _tag: 'CSidebarNavItem',
      name: 'ยอดขายตามลูกค้า',
      to: '/report/report-pos/income-customer',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa fa-file-o" />,
      exact: false,
    })
  }
  if ((permissions['income-product'] && permissions['income-product'].permission_view) || demo_version) {
    pos_items.push({
      _tag: 'CSidebarNavItem',
      name: 'ยอดขายตามสินค้า',
      to: '/report/report-pos/income-product',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa fa-file-o" />,
      exact: false,
    })
  }

  if ((permissions['income-receipt'] && permissions['income-receipt'].permission_view) || demo_version) {
    pos_items.push({
      _tag: 'CSidebarNavItem',
      name: 'ยอดขายตามบิล',
      to: '/report/report-pos/income-receipt',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa fa-file-o" />,
      exact: false,
    })
  }

  if ((permissions['income-sale'] && permissions['income-sale'].permission_view) || demo_version) {
    pos_items.push({
      _tag: 'CSidebarNavItem',
      name: 'ยอดขายตามพนักงาน',
      to: '/report/report-pos/income-sale',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa fa-file-o" />,
      exact: false,
    })
  }
  if ((permissions['report-receipt'] && permissions['report-receipt'].permission_view) || demo_version) {
    pos_items.push({
      _tag: 'CSidebarNavItem',
      name: 'ยอดขายหน้าร้าน',
      to: '/report/report-pos/receipt',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa fa-file-o" />,
      exact: false,
    })
  }
  if ((permissions['report-sale-day'] && permissions['report-sale-day'].permission_view) || demo_version) {
    pos_items.push({
      _tag: 'CSidebarNavItem',
      name: 'ยอดขายรายวัน',
      to: '/report/report-pos/report-sale-day',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa fa-file-o" />,
      exact: false,
    })
  }
  if ((permissions['report-sale-month'] && permissions['report-sale-month'].permission_view) || demo_version) {
    pos_items.push({
      _tag: 'CSidebarNavItem',
      name: 'ยอดขายรายเดือน',
      to: '/report/report-pos/report-sale-month',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa fa-file-o" />,
      exact: false,
    })
  }
  if ((permissions['report-sale-year'] && permissions['report-sale-year'].permission_view) || demo_version) {
    pos_items.push({
      _tag: 'CSidebarNavItem',
      name: 'ยอดขายรายปี',
      to: '/report/report-pos/report-sale-year',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa fa-file-o" />,
      exact: false,
    })
  }
  if ((permissions['report-product-category'] && permissions['report-product-category'].permission_view) || demo_version) {
    pos_items.push({
      _tag: 'CSidebarNavItem',
      name: 'ยอดขายตามหมวดหมู่สินค้า',
      to: '/report/report-pos/report-product-category',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa fa-file-o" />,
      exact: false,
    })
  }
  if ((permissions['report-receipt'] && permissions['report-receipt'].permission_view) || demo_version) {
    pos_items.push({
      _tag: 'CSidebarNavItem',
      name: 'ยกเลิกใบเสร็จ',
      to: '/report/report-pos/receipt-cancel',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa fa-file-o" />,
      exact: false,
    })
  }
  if ((permissions['account-receivable'] && permissions['account-receivable'].permission_view) || demo_version) {
    debtor_items.push({
      _tag: 'CSidebarNavItem',
      name: 'สถานะลูกหนี้',
      to: "/report/report-debtor/account-receivable",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa fa-file-o" />,
      exact: false,
    })
  }
  if ((permissions['aging-analysis'] && permissions['aging-analysis'].permission_view) || demo_version) {
    debtor_items.push({
      _tag: 'CSidebarNavItem',
      name: 'วิเคราะห์อายุลูกหนี้',
      to: '/report/report-debtor/aging-analysis',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa fa-file-o" />,
      exact: false,
    })
  }
  
  pos_items.length && reports.push({
    _tag: "CSidebarNavDropdown",
    name: "รายงานขายหน้าร้าน",
    route: '/report/report-pos',
    icon: <i className="c-sidebar-nav-icon fa fa-list" />,
    _children: pos_items,
  })

  debtor_items.length && reports.push({
    _tag: "CSidebarNavDropdown",
    name: "รายงานลูกหนี้",
    route: '/report/report-debtor',
    icon: <i className="c-sidebar-nav-icon fa fa-list" />,
    _children: debtor_items,
  })

  const creditor_items = []
  if ((permissions['purchase-orders'] && permissions['purchase-orders'].permission_view) || demo_version) {
    creditor_items.push({
      _tag: 'CSidebarNavItem',
      name: 'รายงานใบสั่งซื้อสินค้า',
      to: '/report/report-creditor/purchase-orders',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa fa-file-o" />,
      exact: false,
    })
  }
  if ((permissions['debtor-report'] && permissions['debtor-report'].permission_view) || demo_version) {
    creditor_items.push({
      _tag: 'CSidebarNavItem',
      name: 'รายงานใบรับสินค้า',
      to: "/report/report-creditor/debtor-report",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa fa-file-o" />,
      exact: false,
    })
  }
  if ((permissions['credit'] && permissions['credit'].permission_view) || demo_version) {
    creditor_items.push({
      _tag: 'CSidebarNavItem',
      name: 'รายงานจ่ายชำระหนี้',
      to: "/report/report-creditor/credit",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa fa-file-o" />,
      exact: false,
    })
  }
  if ((permissions['credit-pay'] && permissions['credit-pay'].permission_view) || demo_version) {
    creditor_items.push({
      _tag: 'CSidebarNavItem',
      name: 'รายงานเจ้าหนี้คงค้าง',
      to: "/report/report-creditor/credit-pay",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa fa-file-o" />,
      exact: false,
    })
  }
  if ((permissions['creditor-list'] && permissions['creditor-list'].permission_view) || demo_version) {
    creditor_items.push({
      _tag: 'CSidebarNavItem',
      name: 'รายงานสถานะเจ้าหนี้',
      to: "/report/report-creditor/creditor-list",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa fa-file-o" />,
      exact: false,
    })
  }
  if ((permissions['creditor-report'] && permissions['creditor-report'].permission_view) || demo_version) {
    creditor_items.push({
      _tag: 'CSidebarNavItem',
      name: 'รายงานวิเคราะห์อายุเจ้าหนี้',
      to: "/report/report-creditor/creditor-report",
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa fa-file-o" />,
      exact: false,
    })
  }

  creditor_items.length && reports.push({
    _tag: "CSidebarNavDropdown",
    name: "รายงานเจ้าหนี้",
    route: '/report/report-creditor',
    icon: <i className="c-sidebar-nav-icon fa fa-list" />,
    _children: creditor_items,
  })

  const tax_items = []
  if ((permissions['report-tax-01'] && permissions['report-tax-01'].permission_view) || demo_version) {
    tax_items.push({
      _tag: 'CSidebarNavItem',
      name: 'ภาษีซื้อ',
      to: '/report/report-tax/report-tax-01',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa fa-file-o" />,
      exact: false,
    })
  }
  if ((permissions['report-tax-02'] && permissions['report-tax-02'].permission_view) || demo_version) {
    tax_items.push({
      _tag: 'CSidebarNavItem',
      name: 'ภาษีขาย',
      to: '/report/report-tax/report-tax-02',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa fa-file-o" />,
      exact: false,
    })
  }
  tax_items.length && reports.push({
    _tag: "CSidebarNavDropdown",
    name: "ภาษี",
    route: '/report/report-tax',
    icon: <i className="c-sidebar-nav-icon fa fa-list" />,
    _children: tax_items,
  })

  const stock_items = []
  if ((permissions['report-stock-01'] && permissions['report-stock-01'].permission_view) || demo_version) {
    stock_items.push({
      _tag: 'CSidebarNavItem',
      name: 'สินค้าและวัตถุดิบ',
      to: '/report/report-stock/report-stock-01',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa fa-file-o" />,
      exact: false,
    })
  }
  if ((permissions['report-stock-02'] && permissions['report-stock-02'].permission_view) || demo_version) {
    stock_items.push({
      _tag: 'CSidebarNavItem',
      name: 'สินค้าคงเหลือ',
      to: '/report/report-stock/report-stock-02',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa fa-file-o" />,
      exact: false,
    })
  }
  if ((permissions['report-stock-03'] && permissions['report-stock-03'].permission_view) || demo_version) {
    stock_items.push({
      _tag: 'CSidebarNavItem',
      name: 'สรุปยอดเคลื่อนไหวสินค้า',
      to: '/report/report-stock/report-stock-03',
      target: _target,
      icon: <i className="c-sidebar-nav-icon fa fa fa-file-o" />,
      exact: false,
    })
  }
  // if ((permissions['report-stock-04'] && permissions['report-stock-04'].permission_view) || demo_version) {
  //   stock_items.push({
  //     _tag: 'CSidebarNavItem',
  //     name: 'รายละเอียดสินค้า',
  //     to: '/report/report-stock/report-stock-04',
  // target: _target,
  //     icon: <i className="c-sidebar-nav-icon fa fa fa-file-o" />,
  //     exact: false,
  //   })
  // }
  stock_items.length && reports.push({
    _tag: "CSidebarNavDropdown",
    name: "สินค้าคงคลัง",
    route: '/report/report-stock',
    icon: <i className="c-sidebar-nav-icon fa fa-list" />,
    _children: stock_items,
  })

  const navigations = []
  notifications.length && navigations.push({ _tag: "CSidebarNavTitle", _children: ["Notifications"], }, ...notifications)
  overview_dashboards.length && navigations.push({ _tag: "CSidebarNavTitle", _children: ["Overview-Dashboard"], }, ...overview_dashboards)
  sales.length && navigations.push({ _tag: "CSidebarNavTitle", _children: ["Sale"], }, ...sales)
  purchases.length && navigations.push({ _tag: "CSidebarNavTitle", _children: ["Purchase"], }, ...purchases)
  stocks.length && navigations.push({ _tag: "CSidebarNavTitle", _children: ["Stock"], }, ...stocks)
  human_resources.length && navigations.push({ _tag: "CSidebarNavTitle", _children: ["Human-Resource"], }, ...human_resources)
  accounts.length && navigations.push({ _tag: "CSidebarNavTitle", _children: ["Account"], }, ...accounts)
  masters.length && navigations.push({ _tag: "CSidebarNavTitle", _children: ["Master-Data"], }, ...masters)
  reports.length && navigations.push({ _tag: "CSidebarNavTitle", _children: ["Report"], }, ...reports)

  return navigations
}

export default accessMenu